import { CSSProperties, ReactNode } from "react";
import { styles } from "./ModulesWithTheme.style";
import { ThemeName, useTheme } from "./utils/useTheme";

export interface ModulesWithThemeProps {
  themeName: ThemeName;
  children: ReactNode[];
}

export const ModulesWithTheme = (props: ModulesWithThemeProps) => {
  const { themeName = ThemeName.DEFAULT, children } = props;
  const theme = useTheme(themeName);
  return (
    <div
      className={styles.root}
      style={
        {
          "--primary-color": theme.primaryColor,
          "--last-module-color": theme.lastModuleColor,
        } as CSSProperties
      }
    >
      {children}
    </div>
  );
};
